import React from 'react';
import CourseCard from './CourseCard';
import AIForBusiness from '../assets/ai_for_biz.png';
import TrainTheAITrainer from '../assets/train_ai_trainer.png';

const courses = [
  {
    image: AIForBusiness,
    title: 'AI for Business',
    description: 'Khóa học dành cho lãnh đạo và chuyên viên doanh nghiệp, cung cấp kiến thức nền tảng về AI và ứng dụng thực tế.',
    tags: ['Lãnh đạo', 'Chuyên viên', '40h'],
    level: 'Cơ bản',
    icon: ''
  },
  {
    image: TrainTheAITrainer,
    title: 'Train the AI Trainer',
    description: 'Chương trình đào tạo giảng viên AI đầu tiên tại Việt Nam, tạo ra đội ngũ AI Trainers chuyên nghiệp.',
    tags: ['Giảng viên', 'Cố vấn', '60h'],
    level: 'Nâng cao',
    icon: ''
  }
];

const CoursesSection = () => {
  return (
    <section className="py-0 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-40 right-40 w-80 h-80 bg-gradient-to-br from-brand-secondary/6 to-brand-primary/6 rounded-full blur-3xl"></div>
        <div className="absolute bottom-40 left-40 w-80 h-80 bg-gradient-to-br from-brand-primary/6 to-brand-secondary/6 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          {/* <div className="inline-block px-6 py-3 bg-gradient-to-r from-indigo-100 to-purple-100 text-indigo-700 font-semibold rounded-full text-sm mb-6 shadow-lg">
            CHƯƠNG TRÌNH ĐÀO TẠO
          </div> */}
          <h2 className="text-display-3 font-display font-black leading-tight tracking-tighter mb-6">
            <span className="text-brand-dark">Đào tạo AI</span><br />
            <span className="text-gradient">chuyên nghiệp</span>
          </h2>
          <p className="text-body-large text-gray-600 max-w-3xl mx-auto leading-relaxed font-body">
            Chương trình đào tạo được thiết kế theo chuẩn quốc tế, từ cơ bản đến nâng cao, 
            giúp xây dựng năng lực AI bền vững cho doanh nghiệp và cá nhân
          </p>
        </div>
        
        {/* Courses Grid - Centered for 2 courses */}
        <div className="flex justify-center mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl">
            {courses.map((course, idx) => (
              <CourseCard key={idx} {...course} />
            ))}
          </div>
        </div>
        
        {/* Training Methodology - Redesigned */}
        <div className="relative mb-20">
          {/* Background Elements */}
          <div className="absolute inset-0 bg-brand-primary/5 rounded-3xl"></div>
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-primary/10 rounded-full blur-2xl"></div>
          <div className="absolute bottom-0 left-0 w-40 h-40 bg-brand-secondary/10 rounded-full blur-2xl"></div>
          
          <div className="relative z-10 p-12">
            {/* Header Section */}
            <div className="text-center mb-16">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-primary rounded-2xl mb-6 shadow-lg">
                <span className="text-3xl">🎓</span>
              </div>
              <h3 className="text-h3 font-display font-bold text-brand-dark mb-4 tracking-tight">
                Phương pháp đào tạo 3 cấp độ
              </h3>
              <p className="text-body-large text-gray-600 max-w-3xl mx-auto leading-relaxed font-body">
                Chương trình "Train the AI Trainer" - Đào tạo giảng viên AI đầu tiên tại Việt Nam, 
                tạo ra hệ sinh thái AI Trainers chuyên nghiệp
              </p>
            </div>
            
            {/* Training Levels - Redesigned */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
              {/* Level 1 */}
              <div className="group relative">
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-16 h-16 bg-brand-primary rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl font-bold text-white">1</span>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-brand-primary tracking-wide uppercase">Cấp độ 1</div>
                      <div className="text-xs text-gray-500">Foundation</div>
                    </div>
                  </div>
                  
                  <h4 className="text-h5 font-display font-bold text-gray-800 mb-4 tracking-tight">
                    Hiểu công nghệ
                  </h4>
                  <p className="text-body text-gray-600 leading-relaxed mb-6">
                    AI literacy - Nền tảng kiến thức về AI và ứng dụng trong doanh nghiệp
                  </p>
                  
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                      <span className="text-sm text-gray-600">Khái niệm cơ bản về AI</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                      <span className="text-sm text-gray-600">Ứng dụng thực tế</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                      <span className="text-sm text-gray-600">Xu hướng công nghệ</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Level 2 */}
              <div className="group relative">
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-16 h-16 bg-brand-secondary rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl font-bold text-white">2</span>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-brand-secondary tracking-wide uppercase">Cấp độ 2</div>
                      <div className="text-xs text-gray-500">Intermediate</div>
                    </div>
                  </div>
                  
                  <h4 className="text-h5 font-display font-bold text-gray-800 mb-4 tracking-tight">
                    Sử dụng công cụ
                  </h4>
                  <p className="text-body text-gray-600 leading-relaxed mb-6">
                    AI tools - Thành thạo các công cụ AI hiện đại và phương pháp ứng dụng
                  </p>
                  
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-secondary rounded-full"></div>
                      <span className="text-sm text-gray-600">Công cụ AI phổ biến</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-secondary rounded-full"></div>
                      <span className="text-sm text-gray-600">Thực hành dự án</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-secondary rounded-full"></div>
                      <span className="text-sm text-gray-600">Tối ưu hóa quy trình</span>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Level 3 */}
              <div className="group relative">
                <div className="bg-white rounded-3xl p-8 shadow-xl border border-white/20 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-16 h-16 bg-brand-dark rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <span className="text-2xl font-bold text-white">3</span>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-brand-dark tracking-wide uppercase">Cấp độ 3</div>
                      <div className="text-xs text-gray-500">Advanced</div>
                    </div>
                  </div>
                  
                  <h4 className="text-h5 font-display font-bold text-gray-800 mb-4 tracking-tight">
                    Phương pháp đào tạo
                  </h4>
                  <p className="text-body text-gray-600 leading-relaxed mb-6">
                    Pedagogy for AI - Kỹ năng giảng dạy và truyền đạt kiến thức AI
                  </p>
                  
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-dark rounded-full"></div>
                      <span className="text-sm text-gray-600">Kỹ năng giảng dạy</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-dark rounded-full"></div>
                      <span className="text-sm text-gray-600">Phương pháp sư phạm</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <div className="w-2 h-2 bg-brand-dark rounded-full"></div>
                      <span className="text-sm text-gray-600">Đánh giá hiệu quả</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Specializations Section */}
            <div className="text-center">
              <h4 className="text-h4 font-display font-bold text-brand-dark mb-8 tracking-tight">
                Chuyên ngành đào tạo
              </h4>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-4xl mx-auto">
                {[
                  { name: 'Tài chính', icon: '💰' },
                  { name: 'Bất động sản', icon: '🏢' },
                  { name: 'Giáo dục', icon: '📚' },
                  { name: 'Sản xuất', icon: '🏭' },
                  { name: 'Bán lẻ', icon: '🛍️' },
                  { name: 'Y tế', icon: '🏥' }
                ].map((spec, idx) => (
                  <div key={idx} className="group">
                    <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 shadow-sm hover:shadow-lg transition-all duration-300 transform hover:scale-105 border border-white/20">
                      <div className="text-2xl mb-2">{spec.icon}</div>
                      <div className="text-sm font-medium text-brand-dark">{spec.name}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoursesSection; 